export default {
  title: 'Ofertă suprapusă în aceeași perioadă',
  buttons: {
    save_as_active: 'Setează ca nouă ofertă activă',
    save_as_inactive: 'Salvează ca Inactivă',
    cancel: 'Anulează',
  },
  description: {
    base: '{{offer}} se suprapune cu oferta activă {{overlappingOffer}} în {{weekday}}{{between}}. Puteți rula o singură ofertă în aceeași perioadă.',
    between: ', între {{start}}-{{end}}',
  },
  how_to_resolve: {
    title: 'Cum să rezolvați: Alegeți o opțiune de mai jos.',
  },
};
